import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "simple-component" }
const _hoisted_2 = {
  key: 0,
  class: "question-sub-caption"
}
const _hoisted_3 = {
  key: 1,
  class: "question-sub-caption n"
}

import { useTestStore } from "@/store/UserTestModule";
import { computed, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleQuestionComponent',
  setup(__props, { expose: __expose }) {

const testStore = useTestStore();
const currentQuestion = computed(() => {
  return testStore.currentQuestion;
});
const selectedAnswers = ref([]);
const answers = computed(() => {
  let options = [] as { label: string; value: string }[];
  currentQuestion.value.answers.forEach((answer) => {
    options.push({ label: answer.text, value: answer.answerId.toString() });
  });
  return options;
});

const isNextDisabledSimple = computed(() => {
  return selectedAnswers.value.length === 0;
});

/**
 * Watches the `selectedAnswers` reactive property and updates the user's answer for the current question accordingly.
 * If there are more than one selected answers and the current question type is 1, the first selected answer is removed.
 * For each selected answer, the `answerUser` property of the corresponding answer object is updated to "true" or "false" based on the selection.
 * Finally, the updated current question is passed to the `testStore.setUserAnswer` method.
 */
watch(selectedAnswers, () => {
  if (
    selectedAnswers.value.length > 1 &&
    currentQuestion.value.questionTypeId === 1
  ) {
    selectedAnswers.value.shift();
  }

  if (selectedAnswers.value.length !== 0) {
    currentQuestion.value.answers.forEach((answer) => {
      let isSelected = selectedAnswers.value.includes(answer.answerId.toString());
      answer.answerUser = isSelected ? "true" : "false";
    });
    testStore.setUserAnswer(currentQuestion.value);
  }
});

watch(currentQuestion, () => {
  selectedAnswers.value = [];
});

__expose({
  isNextDisabledSimple,
});

return (_ctx: any,_cache: any) => {
  const _component_q_option_group = _resolveComponent("q-option-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (currentQuestion.value.questionTypeId === 1)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Выберите один вариант ответа "))
      : (currentQuestion.value.questionTypeId === 2)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Выберите несколько вариантов ответа "))
        : _createCommentVNode("", true),
    _createVNode(_component_q_option_group, {
      modelValue: selectedAnswers.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedAnswers).value = $event)),
      options: answers.value,
      type: "checkbox",
      style: {"width":"100%"}
    }, null, 8, ["modelValue", "options"])
  ]))
}
}

})